import moment from "moment";
import { Card, Col, Row, Button } from "react-bootstrap";
import { withTranslation } from "react-i18next";

function Reagendar({t, cita, handleNext}){
    const paciente = cita?.patientDTO;
    const doctorInfo = cita?.scheduleDTO?.doctor
    const speciality = cita?.speciality
    const scheduleDTO = cita?.scheduleDTO

    const next = () => {
        handleNext("seleccionarFecha")
    }
    return (
        <Row>
            <Col xs="12" md="12">
                <Card>
                    <Card.Header className="text-center bg-primary text-white">
                        <h5 className="m-0 text">{t('informacion_pacientes')}</h5>
                        <p className="m-0 font-size-08rem text">
                            Revisar la información y asegúrate que sea correcta.
                            Los tiempos para cancelación o reagendamiento de cita para 
                            Medicina general y pediatría (2 horas antes) y otras especialidades (24 horas antes) 
                            Si presentas algún contratiempo, recuerda que puedes comunicarte con nuestras líneas de 
                            atención desde tu celular Bogotá al (601) 3077022 ó Línea gratuita nacional: 01 8000 95 44 00
                        </p>
                    </Card.Header>
                    <Card.Body>
                        <Row className="mb-md-4">
                            <Col className="text-right">
                                <Button variant="primary" className="btn1" onClick={next}>{t('siguiente')}</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" md="6">
                                <Row>
                                    <Col>
                                        <p className='section-title'>{ t('paciente_informacion') }</p>
                                        <p className='nombre-paciente'>{ `${paciente?.name} ${paciente?.middleName ?? ''} ${paciente?.lastName} ${paciente?.seccondSurname ?? ''}` }</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <p className='section-info info-resaltado'>Documento: </p>
                                        <p className='section-info info'>{`${paciente.identityDocumentType?.code}: ${paciente.documentNumber}`}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <p className='section-info info-resaltado'>Especialidad: </p>
                                        <p className='section-info info'>{speciality.name}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <p className='section-info info-resaltado'>Fecha y Hora: </p>
                                        <p className='section-info info'>{moment(scheduleDTO?.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD MMM YYYY HH:mm")}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <p className='section-info info-resaltado'>Doctor: </p>
                                        <p className='section-info info'> {`${doctorInfo?.name} ${doctorInfo?.lastName}`}</p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="text-right">
                                <Button variant="primary" className="btn1" onClick={next}>{t('siguiente')}</Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}

export default withTranslation()(Reagendar)